import React, { useEffect, useState } from "react";
import {DKLabel, DKButton, DKLine, DKInput, TOAST_TYPE, showToast, showLoader, removeLoader} from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../../../managers/RouteManager";
import { fetchTotalComponents, selectComponent } from "../../../../Redux/Slices/ComponentListSlice";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategory, fetchCategoryMapping, selectCategory, selectCategoryMapping } from "../../../../Redux/Slices/IRASSettingsSlice";
import Utility, { deepClone } from "../../../../utility/Utility";
import { CONSTANTS, INPUT_TYPE } from "../../../../constants/Constant";
import EmployeeListService from "../../../../services/EmployeeListService";
import IRASService from "../../../../services/IRASService";
import { remove } from "jszip";
import PermissionUtils, { ACTION, MODULE } from "../../../user-permissions/PermissionUtils";

const IRASSettings = (props) => {

    /**Hooks */
    const[mappingComponents, setMappingComponents] = useState([]);
    const [userComponents, setUserComponents] = useState([]);
    const [type, setType] = useState("");
    const [countryCode, setCountryCode] = useState("");
    const [recordId, setRecordId] = useState("");
    const [categories, setCategories] = useState([]);
    const [formValues, setFromValues] = useState({});

    /**Selectors */
    const totalComponent = useSelector(selectComponent);
    const totalCategories = useSelector(selectCategory);
    const categoryMappings = useSelector(selectCategoryMapping)

    /**Dispatcher */
    const dispatch = useDispatch();

    useEffect(() => {
        RouteManager.setPresenter({ props:props });
        loadComponents({});
        loadMasterData();
        loadCategoryMapping();
    },[]);

    useEffect(()=> {
        if(!Utility.isEmptyObject(totalComponent)) {
            if(totalComponent?.components?.length > 0) {
                setUserComponents(totalComponent.components)
            }   
        }
        if(!Utility.isEmpty(totalCategories)) {
            if(totalCategories[0]?.categories?.length > 0) {
                setType(totalCategories[0].type);
                setCountryCode(totalCategories[0].country_code);
                setCategories(totalCategories[0].categories)
            }
        }
    },[totalComponent, totalCategories]);

    useEffect(() => {
        prepareDataForMappedComponents();
    }, [userComponents, categoryMappings])

    const prepareDataForMappedComponents = () => {
        const componentData = deepClone(categoryMappings);
        const mappingComponents = [];
        if (componentData.length > 0) {
            for (let index = 0; index < userComponents.length; index++) {
                let componentElement = {};
                let component = userComponents[index];
                for (let item = 0; item < componentData.length; item++) {
                    let object = componentData[item];
                    setType(object.type)
                    setCountryCode(object.country_code)
                    setRecordId(object.id)
                    let componentArray = object.components;
                    if (componentArray && componentArray.length > 0) {
                        for (let value = 0; value < componentArray.length; value++) {
                            let block = componentArray[value];
                            if (component.id === block.componentId) {
                                componentElement = block;
                                componentElement["hasError"] = false;
                                componentElement["errMsg"] = `Select a valid mapping for ${block.name}`;
                                componentElement["columnCode"] = block.componentId;
                                const groupName = block.category?.name;
                                const groupSeq = block.category?.display_seq;
                                formValues[block.componentId] = {name : groupName.trim(), display_seq: groupSeq};
                                break;
                            } else {
                                componentElement['componentId'] = component.id;
                                componentElement['componentName'] = component.name;
                                componentElement['category'] = component.category;
                                componentElement["hasError"] = false;
                                componentElement["errMsg"] = `Select a valid mapping for ${component.name}`;
                                componentElement["columnCode"] = component.id;
                            }
                        }
                        mappingComponents.push(componentElement);
                    }
                }
            }
        } else {
            userComponents.forEach(object => {
                let componentElement = {};
                componentElement['componentId'] = object.id;
                componentElement['componentName'] = object.name;
                componentElement['category'] = object.category;
                componentElement["hasError"] = false;
                componentElement["errMsg"] = `Select a valid mapping for ${object.name}`;
                componentElement["columnCode"] = object.id;
                mappingComponents.push(componentElement);
            });

        }
        setMappingComponents(mappingComponents);
    }

    const loadComponents = async (config) => {
        try {
          await dispatch(fetchTotalComponents());
        } catch (err) {
          console.error("Error loading components: ", err);
        }
      };
      
    const loadMasterData = async () => {
        try{
            await dispatch(fetchCategory())
        } catch(err) {
            console.error("Error loading components: ", err);
        }
    }

    const loadCategoryMapping = async () => {
        try{
            await dispatch(fetchCategoryMapping())
        } catch(err) {
            console.error("Error loading components: ", err);
        }
    }

    const onCancel = () => {
        RouteManager.navigateToPage(PAGE_ROUTES.DASHBOARD)
    }

    const onSaveMappings = () => {
        if(isInvalid()) {
            return;
        }

        const componentObject = prepareDataToSaveMappedComponent();
        if (!Utility.isEmpty(recordId)) {
            showLoader("Updating mapping... Please wait");
            componentObject['id'] = recordId;

            IRASService.updateMappedComponent(componentObject).then(
                (response) => {
                    if (response) {
                        showToast("Mapping updated successfully", TOAST_TYPE.SUCCESS)
                        removeLoader();
                    } else {
                        removeLoader();
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        } else {
            showLoader("Adding mapping... Please wait");
            IRASService.saveMappedComponent(componentObject).then(
                (response) => {
                    if (response) {
                        setRecordId(response['id']);
                        showToast("Mapping saved successfully", TOAST_TYPE.SUCCESS)
                        removeLoader();
                    } else {
                        removeLoader();
                    }
                }, (error) => {
                    removeLoader();
                }
            );
        }
    }

    const isInvalid = () => {
        let isInvalid = false;
        const mappings = deepClone(mappingComponents);
        const alteredConfig = [];
        for(let i = 0; i <  mappings.length; i++) {
            const field = mappings[i];
            if(Utility.isEmptyObject(formValues[field.componentId])) {
                alteredConfig.push({columnCode: field.componentId, hasError: true})
            }
        }
        if(alteredConfig.length > 0) {
            isInvalid = true;
            EmployeeListService.getAlteredConfigDetails(mappings, alteredConfig, false, {}, {});
            setMappingComponents(mappings);
        }
        return isInvalid;
    }

    const prepareDataToSaveMappedComponent = () => {
        let mappedComponenet = {} ;
        let componentArray = [];
        mappedComponenet['country_code'] = countryCode;
        mappedComponenet['type'] = type;
          userComponents.forEach(object => {
          let componentElement = {};
          let assignedCategory = {};
          let componentControl = "";
          componentElement['componentId'] = object.id;
          componentElement['componentName'] = object.name;
          componentControl = formValues[object.id];
          if(!Utility.isEmptyObject(componentControl)) {
            assignedCategory['display_seq'] = EmployeeListService.getSelectedIdFromObject(componentControl, "display_seq");
            assignedCategory['name'] = ` ${EmployeeListService.getSelectedIdFromObject(componentControl, "name").trim()}`;
          }
          componentElement['category'] = assignedCategory;
          componentArray.push(componentElement);
        });
        mappedComponenet["components"] = componentArray;
        return mappedComponenet;
      }

    const onValueChange = (value, field) => {
        const alteredConfig = [];
        const mappings = deepClone(mappingComponents);
        if(Utility.isEmptyObject(value)) {
            alteredConfig.push({columnCode: field.componentId, hasError: true})
        } else {
            alteredConfig.push({columnCode: field.componentId, hasError: false})
        }
        formValues[field.componentId] = value;
        EmployeeListService.getAlteredConfigDetails(mappings, alteredConfig, false, {}, {});
        setMappingComponents(mappings);
    }

    const getComponentMappingSection = () => {
        return(
            <>
            <div>
                <div className="row" style={{width:"60%"}}>
                    <div className="row">
                        <DKLabel text="Components" className="fw-m fs-m p-l" />
                    </div>
                    <div className="row">
                        <DKLabel text="IR8A Category" className="fw-m fs-m p-l" />
                    </div>
                </div>
                {mappingComponents.map((field, index) => {
                    return(
                        <>
                            <div className="row p-v-m" style={{ width: "60%" }}>
                                <div className="row">
                                    <DKLabel text={field.componentName}className="fs-m p-l" />
                                </div>
                                <div className="row">
                                    <div className="parent-width">
                                        <DKInput
                                            title={""}
                                            value={formValues[field.componentId]}
                                            formatter={(obj) => {
                                                /** How to render a selected option in case of object **/
                                                return obj.display_seq + ". " + obj.name;
                                            }}
                                            type={INPUT_TYPE.DROPDOWN}
                                            required={true}
                                            readOnly={false}
                                            direction={"Vertical"}
                                            options={categories}
                                            onChange={(value) => {
                                                onValueChange(value, field);
                                            }}
                                            dropdownConfig={{
                                                className: "",
                                                style: {},
                                                allowSearch: categories?.length > 6,
                                                searchableKey: "name",
                                                data: categories,
                                                renderer: (index, obj) => {
                                                    /** How to render value in Dropdown in case of object **/
                                                    return <DKLabel className="" text={obj.display_seq + ". " + obj.name} />;
                                                },
                                                onSelect: (index, value) => { },
                                            }}
                                            canValidate={field.hasError}
                                            validator={(value) => {
                                                return !field.hasError;
                                            }}
                                            errorMessage={field.errMsg}
                                        />
                                    </div>
                                </div>
                            </div>
                        </>
                    )
                })}
            </div>
            </>
            
        )
    }

    const getCardSection = () => {
        return(
            <>
                <div className="bg-white pb-l card-shadow mt-l" style={{
          pointerEvents: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "":"none",
          opacity: PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) ? "1":"0.9"
        }}>
                    <DKLabel text="Map Components" className="fw-m fs-l p-l" />
                    <DKLine className="bg-gray3" />
                    {getComponentMappingSection()}
                </div>
            </>
        )
    }

    const getHeader = () => {
        return(
            <>
                <div className="row">
                    <div className="row align-items-center">
                        <DKLabel text="IRAS Settings" className="fw-m fs-l" />
                    </div>
                    <div className="row" style={{justifyContent:"flex-end"}}>
                        <DKButton
                            title={"Cancel"}
                            className="border-m bg-gray1"
                            onClick={() => {
                                onCancel("CANCEL");
                            }}
                        />
                        { PermissionUtils.hasAccess(MODULE.COMPANY_SETTINGS, [ACTION.EDIT]) && <DKButton
                            title={"Save"}
                            className="border-m ml-r bg-button text-white bg-app"
                            onClick={() => {
                                onSaveMappings("VALIDATE");
                            }}
                        />}
                    </div>

                </div>
            </>
        )
    }

    return(
        <>
            <div className="parent-width">
                {getHeader()}
                {getCardSection()}
            </div>
        </>
    )
}

export default IRASSettings;